import { useRef } from "react";
/**
 * Wrap a value in a `ref`. Returns the `ref`.
 *
 * The `ref` is a stable variable that can be used as dependency for
 * useCallback and other hooks to avoid constant retriggering of hooks. This is
 * particularly useful for `useCallback` to create a stable function that
 * references a value that changes frequently.
 *
 * Use `ref.current` to access the current value at any time.
 *
 * @param value The value to wrap
 * @returns The `ref` (`ref.current` is always the current `value`)
 */
export default function useRefValue(value) {
    const ref = useRef(value);
    ref.current = value;
    return ref;
}
